import React from 'react'

export default () => {
  return [
    {
      title: 'PUPPIES',
      menu: [
        {
          title: 'FOR PUPPY SEEKERS',
          items: [
            {
              title: 'Find a Puppy',
              url: '/search-puppies'
            },
            {
              title: 'View All Breeds',
              url: 'https://www.akc.org/dog-breeds'
            },
            {
              title: 'Resources for Getting A Puppy',
              url: '/about-akc-marketplace'
            }
          ]
        },
        {
          title: 'FOR BREEDERS',
          items: [
            {
              title: 'List Your Litter with Marketplace',
              url: '/advertise/breeders'
            },
            {
              title: 'Find Your Puppies the Right Homes',
              url: '/find-puppies-the-right-homes'
            }
          ]
        }
      ]
    },
    {
      title: 'GROOMERS',
      menu: [
        {
          title: 'FOR GROOMER SEEKERS',
          items: [
            {
              icon: <svg height='30' viewBox='0 0 30 30' width='30' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
                <g fill='none' fillRule='evenodd' transform='translate(1 1)'>
                  <circle cx='14' cy='14' r='14' stroke='#007ACC' strokeWidth='2' />
                  <path d='M10.715 13.133l4.398-4.353a.508.508 0 0 1 .73 0 .496.496 0 0 1 0 .723l-4.401 4.357.246.246a.2.2 0 0 1 0 .283l-1.424 1.423a.2.2 0 0 1-.283 0L.028 5.86a.2.2 0 0 1 0-.283L1.45 4.152a.2.2 0 0 1 .283 0l.325.325L6.425.155a.508.508 0 0 1 .73 0 .496.496 0 0 1 0 .723l-4.37 4.326.727.726 4.374-4.329a.508.508 0 0 1 .73 0 .496.496 0 0 1 0 .723L4.24 6.657l.7.7 4.382-4.336a.508.508 0 0 1 .73 0 .496.496 0 0 1 0 .723l-4.384 4.34.726.727 4.39-4.344a.508.508 0 0 1 .73 0 .496.496 0 0 1 0 .723L7.12 9.538l.701.701 4.396-4.326a.508.508 0 0 1 .73 0 .496.496 0 0 1 0 .723L8.562 10.98l.713.713 4.404-4.359a.508.508 0 0 1 .73 0 .496.496 0 0 1 0 .724l-4.407 4.362.714.714z' fill='#007ACC' transform='translate(6 6)' />
                </g>
              </svg>,
              title: 'Find a Groomer',
              url: '/search-groomers'
            },
            {
              title: 'AKC Marketplace for Groomers',
              url: '/about-akc-groomerfinder'
            },
            {
              title: 'How to find a Groomer',
              url: '/find-groomer-for-dog'
            }
          ]
        },
        {
          title: 'FOR GROOMERS',
          items: [
            {
              title: 'List Your Services with Marketplace',
              url: '/advertise/groomers'
            }
          ]
        }
      ]
    },
    {
      title: 'TRAINERS',
      menu: [
        {
          title: 'FOR TRAINER SEEKERS',
          items: [
            {
              icon: <svg height='30' viewBox='0 0 30 30' width='30' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
                <g fill='none' fillRule='evenodd' transform='translate(1 1)'>
                  <circle cx='14' cy='14' r='14' stroke='#007ACC' strokeWidth='2' />
                  <g fill='#007ACC' transform='translate(6 6)'>
                    <path d='M10.397 2.336a.256.256 0 0 1-.253-.223L9.958.703a.257.257 0 1 1 .508-.068l.186 1.41a.257.257 0 0 1-.255.291zm-1.126.372l-1.155-1.08a.257.257 0 0 1 .349-.375l1.155 1.08a.257.257 0 0 1-.349.375zm1.958-.49a.257.257 0 0 1-.08-.355l.835-1.33a.257.257 0 0 1 .434.274l-.835 1.33a.256.256 0 0 1-.354.08z' />
                    <path d='M1.828 10.869c-.36 0-.698-.142-.952-.397a1.347 1.347 0 0 1 .665-2.27c.221-1.944 1.622-3.566 3.636-4.02.31-.07.645-.106.996-.107h.924l4.483.004c.13 0 .24.098.255.227l.08.682.785-.226-.007-.42a.259.259 0 0 1 .257-.26l2.6.001a.256.256 0 0 1 .256.257l-.002 2.15a.257.257 0 0 1-.19.247l-4.844 1.33.002.022c.017.168.033.333.038.499.057 2.291-1.462 4.235-3.692 4.728-.316.07-.64.105-.963.105-1.78 0-3.384-1.047-4.154-2.577-.057.007-.112.025-.17.025h-.003zm4.527-3.487a1.498 1.498 0 0 0-.035 2.994h.017c.832 0 1.49-.655 1.496-1.49a1.494 1.494 0 0 0-1.478-1.504zM1.496 8.749a.829.829 0 0 0-.274 1.358.82.82 0 0 0 .543.237 4.454 4.454 0 0 1-.206-.785 4.924 4.924 0 0 1-.063-.81z' transform='rotate(-15 8.144 8.748)' />
                  </g>
                </g>
              </svg>,
              title: 'Find a Trainer',
              url: '/trainers'
            }
          ]
        },
        {
          title: 'FOR TRAINERS',
          items: [
            {
              title: 'List Your Services with Marketplace',
              url: '/advertise/trainers'
            }
          ]
        }
      ]
    },
    {
      title: 'LIST WITH MARKETPLACE',
      type: 'special',
      menu: [
        {
          items: [
            {
              title: 'Create a Breeder listing',
              url: '/advertise/breeders'
            }
          ]
        },
        {
          items: [
            {
              title: 'Create a Groomer Listing',
              url: '/advertise/groomers'
            }
          ]
        },
        {
          items: [
            {
              title: 'Create a Trainer Listing',
              url: '/advertise/trainers'
            }
          ]
        }
      ]
    }
  ]
}
